"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BillboardWrapper = _interopRequireDefault(require("./BillboardWrapper"));

var _excluded = ["data", "predictionDate"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Predictive Chart component.
 */
var PredictiveChart = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var data = _ref.data,
      predictionDate = _ref.predictionDate,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var columns = data.columns;

  if (columns) {
    columns = columns.map(function (dataSeries) {
      if (dataSeries[0] !== 'x') {
        dataSeries = dataSeries.map(function (element) {
          return typeof element === 'number' ? {
            high: element,
            low: element,
            mid: element
          } : element;
        });
      }

      return dataSeries;
    });
  }

  var regions = [];

  if (predictionDate) {
    regions.push({
      axis: 'x',
      start: predictionDate
    });
  }

  return /*#__PURE__*/_react.default.createElement(_BillboardWrapper.default, _extends({
    data: _objectSpread(_objectSpread({}, data), {}, {
      columns: columns
    }),
    ref: ref,
    regions: regions
  }, otherProps));
});

PredictiveChart.displayName = 'ClayPredictiveChart';
var _default = PredictiveChart;
exports.default = _default;